import { useQuery } from '@tanstack/react-query';
import * as chatApi from '../../api/chat';
import type { ListRoomsParams } from '../../types/chat';
import { chatKeys } from './chatKeys';

export function useChatRooms(params: ListRoomsParams = {}) {
  return useQuery({
    queryKey: chatKeys.rooms(params),
    queryFn: () => chatApi.listRooms(params),
    staleTime: 30_000,
  });
}
